import React from 'react';
import { Eye } from 'lucide-react';

const TaskActions = ({ task, onTaskClick }) => {
  const isAutoVerified = task.status === 'auto_verified';
  const isManualVerified = task.status === 'manually_verified';
  const isNotApplicable = task.status === 'not_applicable';

  if (isAutoVerified || isManualVerified || isNotApplicable) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); onTaskClick(task); }}
        className="px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded hover:bg-gray-100 transition-colors flex items-center gap-1"
      >
        <Eye className="w-3.5 h-3.5" />
        View Details
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={(e) => { e.stopPropagation(); onTaskClick(task); }}
        className="px-3 py-1.5 text-xs font-medium text-teal-700 bg-teal-50 border border-teal-200 rounded hover:bg-teal-100 transition-colors flex items-center gap-1"
      >
        <Eye className="w-3.5 h-3.5" />
        View / Add Evidence
      </button>
    </div>
  );
};

export default TaskActions;
